import TestController from '@/controllers/TestController';
import ITestBeginState from './ITestBeginState';
import LoadingState from './LoadingState';
import StartButtonState from './StartButtonState';
import TryAgainState from './ErrorState';
import TestStartController from '../TestStartController.vue';

class TestStartContext {
  public static readonly LOADING = 'loading';
  public static readonly START = 'start';
  public static readonly ERROR = 'error';

  private stateMap: Map<string, ITestBeginState> = new Map();

  private state: ITestBeginState | undefined;
  private readonly testStartControllerComponent: TestStartController;

  constructor(
    testController: TestController | undefined,
    jwt: string | undefined,
    testStartController: TestStartController
  ) {
    this.testStartControllerComponent = testStartController;
    this.stateMap.set(TestStartContext.LOADING, new LoadingState(this, testController, jwt));
    this.stateMap.set(TestStartContext.START, new StartButtonState(this));
    this.stateMap.set(TestStartContext.ERROR, new TryAgainState(this));

    this.setTestBeginState(TestStartContext.LOADING);
  }

  setTestBeginState(stateKey: string): void {
    this.state = this.stateMap.get(stateKey);
    this.testStartControllerComponent.updateDisplayType();
  }

  set title(title: string) {
    if (title) {
      this.testStartControllerComponent.setTitle(title);
    }
  }

  getTestBeginState(): ITestBeginState | undefined {
    return this.state;
  }

  performFunction(): void {
    this.state?.performFunction();
  }
}

export default TestStartContext;
